import { useForm } from "react-hook-form";

import { useSnackbar } from "providers/SnackbarProvider";
import { useConfirmDialogExit } from "hooks";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import {
  buttonSaveUpdate,
  formUpdatePassword,
  modalUpdatePasswordSubtitle,
  modalUpdatePasswordTitle,
  snackbackPasswordUpdateSuccessSubTitle,
  snackbackPasswordUpdateSuccessTitle,
} from "_constants";
import { updatePassword } from "services";

import { FormUpdatePassword } from "components/form/FormUpdatePassword";
import { useState } from "react";

export const ModalUpdatePassword = ({
  showModal,
  onClose,
}: {
  showModal: boolean;
  onClose: Function;
}) => {
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const { showConfirmDialogExit } = useConfirmDialogExit();
  const { handleSubmit, control, watch, trigger } = useForm({
    defaultValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    shouldFocusError: false,
    mode: "onChange",
  });
  const { showSnackbar } = useSnackbar();

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };
  const resetFormState = () => {
    control._reset();
    onClose();
  };

  const onSubmit = (formData: any) => {
    updatePassword(formData)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbackPasswordUpdateSuccessTitle,
          detail: snackbackPasswordUpdateSuccessSubTitle,
          life: 5000,
        });
        resetFormState();
      })
      .catch((error) => {
        if (error.status === 403) {
          setIsPasswordValid(false);
        }
      });
  };

  return (
    <SingleStepDialog
      onHideCallback={handleDismiss}
      height="418px"
      width="700px"
      header={
        <SingleStepHeaders
          title={modalUpdatePasswordTitle}
          subtitle={modalUpdatePasswordSubtitle}
        />
      }
      body={
        <SingleStepBody
          content={
            <form
              id={formUpdatePassword}
              onSubmit={handleSubmit(onSubmit)}
              className="width-100"
            >
              <FormUpdatePassword
                control={control}
                watch={watch}
                trigger={trigger}
                isPasswordValid={isPasswordValid}
                onFocusPassword={() => setIsPasswordValid(true)}
              />
            </form>
          }
        />
      }
      footer={
        <SingleStepFooter
          dismiss={handleDismiss}
          form={formUpdatePassword}
          labelSubmit={buttonSaveUpdate}
        />
      }
      display={showModal}
      setVisible={() => {}}
    />
  );
};
